import Dom from '../../shared/dom.js';
import Popup from '../../shared/popup.js';
import { Component } from '../component/component.js';
import { FancyItem } from '../fancy-item/fancy-item.js';
import { Utils } from '../utils/utils.js';

export class MenuItem extends Component {

	constructor(item, index, parent) {
		super();
		this.item = item;
		this.index = index;
		this.node = this.getNode();
		this.container = this.node.querySelector('.nav--menu__items');
		this.childs = this.addChilds(item.items);
		this.parent = parent;
		this.body = document.querySelector('body');
		if (item.type === 'category') {
			const menuItems = this.parent.querySelector('.nav--menu__items');
			menuItems.classList.add('--category');
		}
		this.addListeners();
	}

	getTemplate() {
		let template;
		switch (this.item.type) {
			case 'menu':
				template = /* html */ `
            <div class="conf__options">
                <div class="nav--menu__items"></div>
            </div>`;
				break;
			case 'part':
				const madeOrder = this.item.madeOrder;
				const popup = madeOrder ? `
                    <div class="popup" data-popup="200">
                        <div class="popup__message" data-popup-message data-popup-position="left">
                            ${productSheet.conf.MADE_TO_ORDER}
                            <a href="${productSheet.conf.LINK_MADE_TO_ORDER_URL}">${productSheet.conf.LINK_MADE_TO_ORDER_TEXT}</a>
                        </div>
                        <div class="popup__icon" data-popup-icon>
                            <div class="svg-icon">
                                <svg class="ico"><use xlink:href="#ico-made-to-order"></use></svg>
                            </div>
                        </div>
                    </div>
                ` : ``;
				template = /* html */ `
            <div class="nav--menu part conf__option--parent ${this.item.id !== null ? "part-type-" + this.item.id : ""}">
                <div class="nav--menu__item">
	                   <div class="box">
                        <div class="conf__setting">
                            <div class="img">
                                <div class="mask"><img /></div>
                            </div>
							<div class="conf__dett">
								<h5 class="h5">${this.item.name}</h5>
								<div class="category-name"></div>
								<div class="name"></div>
							</div>
                        </div>
                    </div>
                </div>
                <div class="conf__panel" data-panel>
	                <div class="nav--menu__item conf__panel-wrapper">
		                <div class="conf__panel-header">
			                <div class="conf__panel-back"></div>
			                <div class="conf__panel-section">${this.item.name}</div>
		                </div>
		                <div class="nav--menu__items"></div>
                    </div>
					<div class="alert">${productSheet.conf.ALERT}</div>
					<div class="confirm"><div class="btn">${productSheet.conf.CONFIRM}</div></div>
                </div>
            </div>
            `;
				break;
			case 'material':
				template = /* html */ `
				<div class="nav--menu material conf__option--parent">
					<div class="nav--menu__item">
						<div class="conf__dett">
							<h5 class="h5">${this.item.name}</h5>
						</div>
					</div>
					<div class="conf__panel" data-panel>
						<div class="nav--menu__item conf__panel-wrapper">
							<div class="nav--menu__items"></div>
						</div>
					</div>
				</div>
				`;
				break;
			case 'variant':
			case 'group':
				template = /* html */ `
                <div class="nav--menu variant conf__option">
                    <div class="nav--menu__item">
                        <div class="conf__option-title">
                            <h5 class="h5">${this.item.name}</h5>
                        </div>
                        <div class="box">
                             <div class="nav--menu__items"></div>
                        </div>
                    </div>
                </div>
            `;
				break;
			case 'category':
				const info = this.item.content !== '' ? `<svg data-info class="ico"><use xlink:href="#ico-info-new"></use></svg>` : '';
				const material = this.item.material ? `${this.item.material}<br/>` : '';

				var displayStyle = "";
				if (!material && this.item.name == " ") {
					displayStyle = " style='display:none' ";
				}

				const category = this.item.name !== '' ? `<div class="conf__panel-title ${info ? '--info' : ''}">
					<span ${displayStyle} >${material}${this.item.name}</span>${info}
				</div>` : '';				

				template = /* html */ `
                <div class="nav--menu category conf__panel-content">
                    <div class="conf__panel-category">
                        ${category}
                        <div class="nav--menu__items conf__panel-options"></div>
                    </div>
                </div>
            `;
				break;
			case 'option-variant':
				const name = this.item.name;
				let selection = this.item.selection;
				if (name === 'inch') {
					selection = this.cmToInches(selection);
				}
				template = /* html */ `
                    <div class="nav--menu__item conf__setting">${selection} ${this.item.name}</div>
                `;
				break;
			case 'option':
			default:
				const isRounded = this.item.rounded === true;
				const roundedClass = isRounded ? 'conf__panel-setting--rounded' : 'conf__panel-setting';
				const roundedMarkup = isRounded ? `<div class="mask"><img src="${this.item.img}" alt="${this.item.name}" /></div>` :
					`<img src="${this.item.img}" alt="${this.item.name}" />`;
				template = /* html */ `
                <div class="nav--menu option conf__panel-option">
                    <div class="box">
                        <div class="nav--menu__item ${roundedClass}">
                            <div class="img">
                                ${roundedMarkup}
                            </div>
                            <span class="name">${this.item.name}</span>
                        </div>
                    </div>
                </div>
                `;
				break;
		}

		return template;
	}

	cmToInches(value) {
		value = parseFloat(value);
		const inches = value * 0.393701;
		let intPart = Math.floor(inches);
		const decimalPart = inches - intPart;
		let formattedInches = '';
		if (decimalPart > 0 && decimalPart <= 0.125) {
			formattedInches = '<span class="decimalConv">1/8</span>';
		} else if (decimalPart > 0.125 && decimalPart <= 0.25) {
			formattedInches = '<span class="decimalConv">1/4</span>';
		} else if (decimalPart > 0.25 && decimalPart <= 0.375) {
			formattedInches = '<span class="decimalConv">3/8</span>';
		} else if (decimalPart > 0.375 && decimalPart <= 0.5) {
			formattedInches = '<span class="decimalConv">1/2</span>';
		} else if (decimalPart > 0.5 && decimalPart <= 0.625) {
			formattedInches = '<span class="decimalConv">5/8</span>';
		} else if (decimalPart > 0.625 && decimalPart <= 0.75) {
			formattedInches = '<span class="decimalConv">3/4</span>';
		} else if (decimalPart > 0.75 && decimalPart <= 0.875) {
			formattedInches = '<span class="decimalConv">7/8</span>';
		} else if (decimalPart > 0.875 && decimalPart < 1) {
			intPart += 1;
		}
		// console.log('MenuItem.cmToInches', value, inches, intPart, decimalPart, formattedInches);
		return `${intPart} ${formattedInches}`;
	}

	once(items, item, key = 'id') {
		const item_ = items.find(x => x[key] === item[key]);
		if (item_) {
			return item_;
		}
		items.push(item);
		return item;
	}

	addChilds(items) {
		if (items && items.length > 0) {
			const firstItem = items[0];
			if (firstItem.type === 'category' && firstItem.material != null) {
				// console.log(firstItem.material);
				const groupedItems = [];
				items.forEach(item => {
					const group = this.once(groupedItems, {
						name: item.material,
						content: item.content,
						type: 'material',
						items: [],
						orderIndex: item.orderIndex,
						macroOrderIndex: item.macroOrderIndex,
						parent: item.parent,
						isMaterial: true,
					}, 'name');
					const newItem = Object.assign({}, item);
					delete newItem.material;
					group.items.push(newItem);
				});
				items = groupedItems;
				// console.log('groupedItems', groupedItems);
				// items.push(items[0]);
			}
			items = this.filterChildsWithOptions(items);
			const container = this.container;
			const childs = items.map((item, index) => {
				item.name = (item.name && item.name.length) ? item.name : '';
				// item.hasSiblings = items.length > 1;
				if (this.item.type === 'category') {
					item.categoryName = this.item.material ? this.item.material : this.item.name;
				}
				if (this.item.type === 'part' || this.item.type === 'material') {
					item.parent = this.node.querySelector('.conf__panel-wrapper');
				}
				return new MenuItem(item, index, item.parent);
			});
			childs.forEach((item, index) => {
				container.appendChild(item.node);
			});
			return childs;
		}
	}

	addListeners() {
		this.onClick = this.onClick.bind(this);
		this.onBack = this.onBack.bind(this);
		this.onChildSelected = this.onChildSelected.bind(this);
		switch (this.item.type) {
			case 'menu':
				break;
			case 'part':
				const popupWrapper = this.node.querySelector('[data-popup]');
				if (popupWrapper) {
					const popup = new Popup(popupWrapper);
				}
				this.node.querySelector('.nav--menu__item .box').addEventListener('click', this.onClick);
				this.node.querySelector('.conf__panel-back').addEventListener('click', this.onBack);
				this.node.querySelector('.confirm .btn').addEventListener('click', this.onBack);
				break;
			case 'material':
				this.node.querySelector('.nav--menu__item').addEventListener('click', this.onClick);
				break;
			case 'category':
				if (this.item.name && this.item.content) {
					const fancy = new FancyItem(this.item.name, this.item.content, this.node.querySelector('[data-info]'), this.parent);
					this.node.appendChild(fancy.node);
				}
				break;
			case 'option':
				this.node.querySelector('.nav--menu__item').addEventListener('click', this.onClick);
				break;
			case 'option-variant':
				this.node.addEventListener('click', this.onClick);
				break;
			case 'variant':
				break;
		}
		if (this.childs) {
			this.childs.forEach(child => child.on('selected', this.onChildSelected));
		}
	}

	removeListeners() {
		// !!! todo
		const button = this.node.querySelector('.nav--menu__item');
		button.removeEventListener('click', this.onClick);
	}

	destroy() {
		this.removeListeners();
	}

	set disabled(disabled) {
		disabled ? this.node.classList.add('disabled') : this.node.classList.remove('disabled');
		if (!disabled) {
			return;
		}
		/*
		if (productSheet.typeDB === 'divd3') {
			this.node.style.display = 'none';
			return;
		}
		*/
		const panel = Utils.getClosest(this.node, '.conf__panel');
		if (panel && !panel.classList.contains('conf__panel--alert-on')) {
			panel.classList.add('conf__panel--alert-on');
		}
	}

	hasSubOptions(items) {
		if (!items) {
			return false;
		}
		if (items.length > 1) {
			return true;
		} else {
			return items.reduce((p, c) => {
				return p || this.hasSubOptions(c.items);
			}, false);
		}
	}

	filterChildsWithOptions(items) {
		return items.filter(x => {
			if (!x.items) {
				return true;
			} else if ((x.items && x.items.length > 0) || (this.item.type !== 'menu')) {
				return true;
			} else {
				return this.hasSubOptions(x.items);
			}
		});
	}

	toggle() {
		if (Dom.mobile && !this.scrollvalue) {
			this.scrollvalue = document.documentElement.scrollTop;
		}
		this.active = !this.active;
		if (!this.active) {
			this.node.classList.remove('active');
			this.body.classList.remove('conf--open');
			if (Dom.mobile && this.scrollvalue) {
				window.scrollTo(0, this.scrollvalue);
				this.scrollvalue = null;
			}
		} else {
			if (Dom.mobile) {
				window.scrollTo(0, 0);
			}
		}
		// console.log('toggle', this.active);
		return this.active;
	}

	openFirstPart() {
		switch (this.item.type) {
			case 'part':
				this.active = true;
				this.node.classList.add('active');
				this.body.classList.add('conf--open');
				break;
		}
		if (this.childs) {
			const firstPart = this.childs.find(x => x.item.type === 'part');
			if (firstPart) {
				firstPart.openFirstPart();
			} else {
				this.childs.forEach((child, i) => child.openFirstPart());
			}
		}
	}

	reset() {
		switch (this.item.type) {
			case 'part':
				if (this.active) {
					this.active = false;
					this.node.classList.remove('active');
					this.body.classList.remove('conf--open');
				}
				break;
		}
		if (this.childs) {
			this.childs.forEach(child => child.reset());
		}
	}

	onBack() {
		this.toggle();
	}

	onClick(event) {
		switch (this.item.type) {
			case 'option':
			case 'option-variant':
				this.emit('selected', [{ item: this.item, index: this.index }]);
				break;
			default:
				if (this.toggle()) {
					this.emit('selected', [{ item: this.item, index: this.index }]);
					this.body.classList.add('conf--open');
				}
		}
	}

	onChildSelected(events) {
		const index = events[0].index;
		const container = this.container;
		const isSlick = container.childNodes && container.childNodes[0].classList.contains('nav--menu') ? false : true;
		const childNodes = isSlick ? Array.prototype.slice.call(container.querySelectorAll('.slick-track>.slick-slide>div>.nav--menu')) : container.childNodes;
		childNodes.forEach((node, i) => {
			const instance = this.childs[i];
			if (i === index) {
				instance.active = true;
				node.classList.add('active');
			} else {
				instance.active = false;
				node.classList.remove('active');
			}
		});
		if (this.item.type !== 'menu' && !this.item.isMaterial) {
			events.unshift({ item: this.item, index: this.index });
		}
		this.emit('selected', events);
	}

	getOptionsByType(childs, type, options) {
		options = options || [];
		if (childs) {
			childs.forEach(x => {
				if (x.item.type === type) {
					options.push(x);
				}
				options = this.getOptionsByType(x.childs, type, options);
			});
		}
		return options;
	}

	updatePart(part) {
		let options, option;
		switch (this.item.type) {
			case 'part':
				options = this.getOptionsByType(this.childs, 'option');
				const categories = this.getOptionsByType(this.childs, 'category');
				categories.forEach(category => {
					category.node.classList.remove('active');
				});
				const materials = this.getOptionsByType(this.childs, 'material');
				materials.forEach(material => {
					material.node.classList.remove('active');
				});
				break;
			case 'variant':
				options = this.getOptionsByType(this.childs, 'option-variant');
				break;
		}
		if (options) {
			option = options.find(x => x.item.selection && x.item.selection.toString() === part.selection.toString());
		}
		if (option) {
			options.forEach(x => x.node.classList.remove('active'));
			option.node.classList.add('active');
			switch (this.item.type) {
				case 'part':
					const materials = this.getOptionsByType(this.childs, 'material');
					materials.forEach(material => {
						const categories = material.getOptionsByType(material.childs, 'category');
						const active = categories.reduce((p, category) => {
							const has = category.childs.includes(option);
							// console.log(category, has, option);
							category.node.classList.toggle('active', has);
							return p || has;
						}, false);
						// console.log(material, active);
						material.node.classList.toggle('active', active);
					});
					if (materials.length === 0) {
						const categories = this.getOptionsByType(this.childs, 'category');
						categories.forEach(category => {
							const active = category.childs.includes(option);
							category.node.classList.toggle('active', active);
						});
					}
					this.node.querySelector('.category-name').innerHTML = option.item.categoryName || '';
					this.node.querySelector('.name').innerHTML = option.item.name;
					this.node.querySelector('img').src = option.item.img;
					const setting = this.node.querySelector('.conf__setting');
					if (setting && option.item.rounded) {
						setting.classList.add('conf__setting--rounded');
						setting.classList.remove('conf__setting');
					}
					break;
				case 'variant':
					break;
			}
		}
	}

	updateMenu(parts) {
		parts.forEach(part => {
			const id = part.ID;
			const child = this.childs.find(x => {
				return (x.item.configurableID && x.item.configurableID === id) || (x.item.type === 'variant' && x.item.type === id);
			});
			if (child) {
				child.updatePart(part);
			}
		});
	}

	setDisabledStates(callback) {
		if (this.childs) {
			this.childs.forEach(x => {
				if (x.childs) {
					x.childs.forEach(c => {
						if (c.childs) {
							c.childs.forEach(o => {
								const valid = callback(x.item.configurableID, o.item.selection);
								o.disabled = !valid;
							});
						} else if (c.item.type === 'option-variant') {
							const valid = callback(c.item.configurableID, c.item.selection);
							c.disabled = !valid;
						}
					});
				}
			});
		}
	}
}
